import { Reducer } from 'redux';
import { Action, ActionType } from '../../actions';
import { TableData } from '../../state/Supplier/TableData';

const updateSupplierTableData: Reducer<TableData> = (state: TableData = new TableData(), action: Action<ActionType, any>) => {
  switch (action.type) {
    case ActionType.SUPPLIER_TABLE_DATA_FETCHED:      
      return { ...state, items: action.data?.items ?? [], totalItems: action.data?.totalItems };
    default:
      return state;
  }
};

export default updateSupplierTableData;
